import { Dispatch, SetStateAction } from 'react';

import { Button, Modal, ModalInner } from 'components';
import { ContactProfileGridData } from './types';
import axios from 'common/AxiosAuth';

interface ModalProps {
  data: ContactProfileGridData[] | null;
  setData: Dispatch<SetStateAction<ContactProfileGridData[] | null>>;
  onDeleted: () => void;
  setCheckedRows: (rows: number[]) => void;
}

const DeleteModal = ({ data, setData , onDeleted, setCheckedRows}: ModalProps) => {
  async function onDelete() {
    if(data && data.length > 0) {
      const ids = data.map(item => item.contactProfileId);
      try {
        await axios.delete('/api/contactprofile/removeContactProfiles', {
          data: ids
        });
        onDeleted();
        setData(null);
        setCheckedRows([]); // 체크박스 초기화
      } catch (error) {
        console.error("Error deleting items:", error);
      }
    }
  }

  function onCancel() {
    setData(null);
  }

  return (
    <Modal isOpened={!!data}>
      <ModalInner className="md:w-[400px]" title="Delete" onClickClose={onCancel}>
        <p className=" p-4 pt-0 text-body1">Are you sure you want to delete it? This operation cannot be undone.</p>
        <div className="flex w-full flex-row items-center justify-between bg-bg-transparent_gray_light p-4">
          <Button className="h-9" text="Cancel" onClick={onCancel} type="secondary" size="large" />
          <Button className="h-9 bg-red-600 border-red-600" text="Delete" onClick={onDelete} type="blue" size="large" />
        </div>
      </ModalInner>
    </Modal>
  );
};

export default DeleteModal;
